import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { updateData, getDate, validateEmail } from '../../assets/js/functions';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Swal from 'sweetalert2';
import logo from '../../assets/images/logo-boticario.png';
import titulo from '../../assets/images/image_header_boticario.png';
import ModalComponent from '../../components/Modal';
import './styles.scss';

export default function Login() {
  const navigate = useNavigate();
  const [modo, setModo] = useState('registro');
  const [showPassword, setShowPassword] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const [nombre, setNombre] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [cargo, setCargo] = useState('');
  const [cedula, setCedula] = useState('');
  const [ciudad, setCiudad] = useState('');
  const [correoReg, setCorreoReg] = useState('');
  const [passwordReg, setPasswordReg] = useState('');
  const [autoriza, setAutoriza] = useState(false);

  const [correoLogin, setCorreoLogin] = useState('');
  const [passwordLogin, setPasswordLogin] = useState('');

  const swalError = (text) => Swal.fire({ title: '¡Atención!', text, icon: 'warning', confirmButtonText: 'Cerrar', confirmButtonColor: '#19336d' });

  const registrar = async (e) => {
    e.preventDefault();
    if (!nombre || !ciudad || !cedula || !correoReg || !passwordReg) return swalError('Por favor completa todos los campos.');
    if (!validateEmail(correoReg)) return swalError('Ingresa un correo válido.');
    if (passwordReg.length < 6) return swalError('La contraseña debe tener al menos 6 caracteres.');
    if (!autoriza) return swalError('Debes autorizar el tratamiento de datos para continuar.');
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, correoReg, passwordReg);
      const uid = userCredential.user.uid;
      await updateData('usuarios', uid, {
        uid,
        nombre,
        cedula,
        ciudad,
        correo: correoReg.toLowerCase(),
        autorizaDatos: true,
        fecha: getDate(),
      });
      sessionStorage.setItem(process.env.REACT_APP_ID_SESSION, uid);
      Swal.fire({ title: '¡Registro exitoso!', text: 'Bienvenido a la plataforma.', icon: 'success', confirmButtonText: 'Continuar', confirmButtonColor: '#19336d' }).then(() => navigate('/streaming'));
    } catch (error) {
      let msg = 'No se pudo completar el registro.';
      if (error.code === 'auth/email-already-in-use') msg = 'Este correo ya está registrado. Intenta iniciar sesión.';
      swalError(msg);
    }
  };

  const ingresar = async (e) => {
    e.preventDefault();
    if (!correoLogin || !passwordLogin) return swalError('Por favor ingresa tu correo y contraseña.');
    try {
      const userCredential = await signInWithEmailAndPassword(auth, correoLogin, passwordLogin);
      sessionStorage.setItem(process.env.REACT_APP_ID_SESSION, userCredential.user.uid);
      navigate('/streaming');
    } catch {
      swalError('Correo y/o contraseña incorrectos.');
    }
  };

  return (
    <div id='login'>
      <div className='titulo'>
        <img src={titulo} alt='logo' className='login-title' />
      </div>
      <div className='login-card'>
        {/* LOGO */}
        <div className='login-logo-wrap'>
          <img src={logo} alt='logo' className='login-logo' />
        </div>

        {/* TABS */}
        <div className='login-tabs'>
          <button className={`tab ${modo === 'registro' ? 'active' : ''}`} onClick={() => setModo('registro')}>
            Registrarme
          </button>
          <button className={`tab ${modo === 'login' ? 'active' : ''}`} onClick={() => setModo('login')}>
            Iniciar sesión
          </button>
        </div>

        {/* SUBTÍTULO */}
        <p className='login-subtitle'>Ingresa tus datos para acceder a la plataforma del evento en vivo</p>

        {/* FORMULARIO REGISTRO */}
        {modo === 'registro' ? (
          <form onSubmit={registrar} className='login-form'>
            <div className='field'>
              <label>Nombre</label>
              <input placeholder='Juan González' value={nombre} onChange={(e) => setNombre(e.target.value)} />
            </div>
            <div className='field'>
              <label>Cédula</label>
              <input placeholder='1045123451' value={cedula} onChange={(e) => setCedula(e.target.value)} />
            </div>
            <div className='field'>
              <label>Ciudad</label>
              <input placeholder='Cali' value={ciudad} onChange={(e) => setCiudad(e.target.value)} />
            </div>
            <div className='field'>
              <label>Correo</label>
              <input type='email' placeholder='usuario@mail.com' value={correoReg} onChange={(e) => setCorreoReg(e.target.value)} />
            </div>
            <div className='field'>
              <label>Contraseña</label>
              <div className='input-password'>
                <input type={showPassword ? 'text' : 'password'} placeholder='Mínimo 6 caracteres' value={passwordReg} onChange={(e) => setPasswordReg(e.target.value)} />
                <IconButton onClick={() => setShowPassword((s) => !s)} size='small' className='eye-btn'>
                  {showPassword ? <VisibilityOff fontSize='small' /> : <Visibility fontSize='small' />}
                </IconButton>
              </div>
            </div>
            <FormControlLabel
              className='checkbox-label'
              control={<Checkbox checked={autoriza} onChange={(e) => setAutoriza(e.target.checked)} size='small' sx={{ color: '#7ab3f5', '&.Mui-checked': { color: '#7ab3f5' }, padding: '4px 8px' }} />}
              label={
                <>
                  Autorización de tratamiento de datos personales según el{' '}
                  <span
                    className='privacy-link'
                    onClick={(e) => {
                      e.preventDefault();
                      setModalOpen(true);
                    }}
                    style={{
                      color: '#1976d2',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                  >
                    aviso de privacidad
                  </span>
                </>
              }
            />
            <button type='submit' className='btn-primary'>
              Registrarme
            </button>
          </form>
        ) : (
          /* FORMULARIO LOGIN */
          <form onSubmit={ingresar} className='login-form'>
            <div className='field'>
              <label>Correo</label>
              <input type='email' placeholder='usuario@mail.com' value={correoLogin} onChange={(e) => setCorreoLogin(e.target.value)} />
            </div>
            <div className='field'>
              <label>Contraseña</label>
              <div className='input-password'>
                <input type={showPassword ? 'text' : 'password'} placeholder='Tu contraseña' value={passwordLogin} onChange={(e) => setPasswordLogin(e.target.value)} />
                <IconButton onClick={() => setShowPassword((s) => !s)} size='small' className='eye-btn'>
                  {showPassword ? <VisibilityOff fontSize='small' /> : <Visibility fontSize='small' />}
                </IconButton>
              </div>
            </div>
            <button type='submit' className='btn-primary'>
              Ingresar
            </button>
          </form>
        )}
      </div>

      {/* PRIVACY MODAL */}
      <ModalComponent
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        PaperProps={{
          style: { backgroundColor: '#fff', color: '#000', boxShadow: 'none' },
        }}
      >
        <div className='privacy-modal-content'>
          <h2>AUTORIZACIÓN DE TRATAMIENTO DE DATOS PERSONALES</h2>
          <p>
            He leído y autorizo el Tratamiento de mis Datos Personales, conforme a
            la Política de Tratamiento de Datos Personales publicada en la página
            web de Grupo Boticário., en la dirección:{' '}
            <a
              href=''
              target='_blank'
              rel='noopener noreferrer'
            >
              
            </a>.
            La empresa actuará como Responsable del Tratamiento de mis Datos
            Personales.
          </p>
          <button className='btn-secondary' onClick={() => setModalOpen(false)}>
            Cerrar
          </button>
        </div>
      </ModalComponent>
    </div>
  );
}
